import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'

//import RouterProtection from '@/router/protection'

//Auth
import Login from '@/components/Auth/Login'
import Reset from '@/components/Auth/ResetPassword'
import Request from '@/components/Auth/RequestPassword'

//dashboard
import Dashboard from '@/views/Dashboard'
import DashAdmin from '@/components/AdminView/DashAdmin'
import DashAluno from '@/components/AlunoView/DashAlunoSelector'
import DashCorretor from '@/components/CorretorView/DashCorretor'
import DashDiretor from '@/components/DiretorView/DashDiretor'

/////////////////
//  cruds      //   /////////////////
//|||||||||||||//   //   methods   //
//   User      //   /////////////////
//   Escola    //   //   index     //   
//   Turma     //   //   info      //   
//   Aluno     //   //   create    //   
//   Correcao  //   //   update    //  
//   Redacao   //   //   delete    //   
//   Proposta  //   /////////////////
//   Simulado  //   
//   Grade     //   
//   Corretor  //
///////////////// 


//#################################
//# DIRETOR
//#################################


//!turma
import DiretorTurma from '@/components/DiretorView/Turma/Index'
import DiretorTurmaCreate from '@/components/DiretorView/Turma/Create'
import DiretorTurmaUpdate from '@/components/DiretorView/Turma/Update'

//!diretor
import DiretorPerfil from '@/components/DiretorView/Perfil/index'

//!redacao
//import DiretorRedacao from '@/components/DiretorView/Redacao/Index'

//!simulado
import DiretorSimulado from '@/components/DiretorView/Simulado/index'
import DiretorSimuladoCreate from '@/components/DiretorView/Simulado/Create'
import DiretorSimuladoUpdate from '@/components/DiretorView/Simulado/Update'


//################################
//# ADMIN
//################################


//!Escola
import AdminEscolaIndex from '@/components/AdminView/Escola/Index'
import AdminEscolaCreate from '@/components/AdminView/Escola/Create'
import AdminEscolaUpdate from '@/components/AdminView/Escola/Update'

//!Turma
import AdminTurmaIndex from '@/components/AdminView/Turma/Index'
import AdminTurmaCreate from '@/components/AdminView/Turma/Create'
import AdminTurmaUpdate from '@/components/AdminView/Turma/Update'

//!Redacao
//import AdminRedacao from '@/components/AdminView/Redacao/Index'

//!Simulado
import AdminSimulado from '@/components/AdminView/Simulado/index'

//!Teaser
import AdminTeaserIndex from '@/components/AdminView/Teaser/Index'
import AdminTeaserCreate from '@/components/AdminView/Teaser/Create'
import AdminTeaserUpdate from '@/components/AdminView/Teaser/Update'

//!Grade
import AdminGradeCreate from '@/components/AdminView/Grade/Create'
import AdminGradeUpdate from '@/components/AdminView/Grade/Update'

//!Corretor
import AdminCorretorIndex from '@/components/AdminView/Corretor/Index'
import AdminCorretorCreate from '@/components/AdminView/Corretor/Create'
import AdminCorretorUpdate from '@/components/AdminView/Corretor/Update'

//!Diretor
import AdminDiretorIndex from '@/components/AdminView/Diretor/Index'
import AdminDiretorCreate from '@/components/AdminView/Diretor/Create'
import AdminDiretorUpdate from '@/components/AdminView/Diretor/Update'

//!Perfil
import AdminPerfilIndex from '@/components/AdminView/Perfil/Index'

//!Biblioteca
import AdminBiblioteca from '@/components/AdminView/Biblioteca/DashBiblioteca'


//#################################
//# ALUNO
//#################################


//!Redacao
//import AlunoRedacaoIndex from '@/components/AlunoView/Redacao/Index' // (index redacao)
//import AlunoRedacaoCreate from '@/components/AlunoView/Redacao/Create'
//import AlunoRedacaoUpdate from '@/components/AlunoView/Redacao/Update'

//!Videos
import AlunoVideosIndex from '@/components/AlunoView/Videos/Index'

//!Simulado
import AlunoSimuladoIndex from '@/components/AlunoView/Simulado/Index'

//!Perfil
import AlunoPerfilIndex from '@/components/AlunoView/Perfil/Index'


//##################################
//# CORRETOR
//##################################


//!Correcao
//import CorretorCorrigirIndex from '@/components/CorretorView/Corrigir/Index' // (redacao index)
//import CorretorCorrigirCreate from '@/components/CorretorView/Corrigir/Create' // (corrigir)

//!Perfil
import CorretorPerfilIndex from '@/components/CorretorView/Perfil/Index'



/*********
 * REFATORANDO CÓDIGO
 */

import MaterialIndex from '@/views/Material/Index'
import MaterialSave from '@/views/Material/Save' // Create and Update

import PropostaIndex from '@/views/Proposta/Index'
import PropostaSave from '@/views/Proposta/Save' // Create and Update
import PropostaVideoaula from '@/views/Proposta/Videoaula'

import AlunoIndex from '@/views/Aluno/Index'
import AlunoSave from '@/views/Aluno/Save'

import RedacaoIndex from '@/views/Redacao/Index' // All
import RedacaoSave from '@/views/Redacao/Save' // Aluno
import RedacaoCorrigir from '@/views/Redacao/Corrigir' // Corretor

/****************** 
 */

/**

Regex for replace metas (vscode: ctrl + H)

meta: \{[\n \w\.,:\t]*\} ----> Find
meta: meta               ----> Replace

*/
/********* */
/**
*/


Vue.use(Router)

var meta = {
  guest: false,
  aluno: store.getters.isAluno,
  corretor: store.getters.isCorretor,
  diretor: store.getters.isDiretor,
  admin: store.getters.isAdmin,
  cargo: store.getters.cargo,
  cargoId: store.getters.cargo_id
}

/* eslint-disable no-console */
//console.log(meta);


let router = new Router({
  mode: 'history',
  routes: [

    // Auth
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { //
        guest: true
      }
    }, {
      path: '/password/reset/:token',
      name: 'password/reset',
      component: Reset,
      meta: { //
        guest: true
      }
    }, {
      path: '/password/request',
      name: 'password/request',
      component: Request,
      meta: { //
        guest: true
      }
    },
    // Dashboard Aluno
    {
      path: '/dashaluno',
      name: 'dashaluno',
      component: DashAluno,
      meta: meta
    },
    // Dashboard Corretor
    {
      path: '/dashcorretor',
      name: 'dashcorretor',
      component: DashCorretor,
      meta: meta
    },
    // Dashboard Diretor
    {
      path: '/dashdiretor',
      name: 'dashdiretor',
      component: DashDiretor,
      meta: meta
    },
    // Dashboard Admin
    {
      path: '/dashadmin',
      name: 'dashadmin',
      component: DashAdmin,
      meta: meta
    },


    //####################################################################
    //# DIRETOR
    //####################################################################
    
    
    {
      path: '/diretor/turma/:cargo_id',
      name: 'diretor/turma',
      component: DiretorTurma,
      meta: meta
    }, {
      path: '/diretor/turma/create',
      name: 'diretor/turma/create',
      component: DiretorTurmaCreate,
      meta: meta
    }, {
      path: '/diretor/turma/update',
      name: 'diretor/turma/update',
      component: DiretorTurmaUpdate,
      meta: meta
    }, {
      path: '/diretor/perfil/:cargo_id',
      name: 'diretor/perfil',
      component: DiretorPerfil,
      meta: meta
    }, 
   /*
    {
      path: '/diretor/redacao/:cargo_id',
      name: 'diretor/redacao',
      component: DiretorRedacao,
      meta: meta
    },
    */
   {
      path: '/diretor/simulado/:cargo_id',
      name: 'diretor/simulado',
      component: DiretorSimulado,
      meta: meta
    }, {
      path: '/diretor/simulado/create',
      name: 'diretor/simulado/create',
      component: DiretorSimuladoCreate,
      meta: meta
    }, {
      path: '/diretor/simulado/update',
      name: 'diretor/simulado/update',
      component: DiretorSimuladoUpdate,
      meta: meta
    },


    //####################################################################
    //# ADMIN
    //####################################################################


    //!Perfil
    {
      path: '/admin/perfil/:cargo_id',
      name: 'admin/perfil',
      component: AdminPerfilIndex,
      meta: meta
    },

    //!Escola
    {
      path: '/admin/escola',
      name: 'admin/escola',
      component: AdminEscolaIndex,
      meta: meta
    }, {
      path: '/admin/escola/create',
      name: 'admin/escola/create',
      component: AdminEscolaCreate,
      meta: meta
    }, {
      path: '/admin/escola/update/:uuid',
      name: 'admin/escola/update',
      component: AdminEscolaUpdate,
      meta: meta
    },

    //!Turma
    {
      path: '/admin/turma',
      name: 'admin/turma',
      component: AdminTurmaIndex,
      meta: meta
    }, {
      path: '/admin/turma/create',
      name: 'admin/turma/create',
      component: AdminTurmaCreate,
      meta: meta
    }, {
      path: '/admin/turma/update/:uuid',
      name: 'admin/turma/update',
      component: AdminTurmaUpdate,
      meta: meta
    },

    //!Redacao
    /*
    {
      path: '/admin/redacao',
      name: 'admin/redacao',
      component: AdminRedacao,
      meta: meta
    },
    */
    {
      path: '/admin/biblioteca/simulado',
      name: 'admin/simulado',
      component: AdminSimulado,
      meta: meta
    },

    //Teaser
    {
      path: '/admin/biblioteca/teaser',
      name: 'admin/biblioteca/teaser',
      component: AdminTeaserIndex,
      meta: meta
    }, {
      path: '/admin/biblioteca/teaser/create',
      name: 'admin/biblioteca/teaser/create',
      component: AdminTeaserCreate,
      meta: meta
    }, {
      path: '/admin/biblioteca/teaser/update/:uuid',
      name: 'admin/biblioteca/teaser/update',
      component: AdminTeaserUpdate,
      meta: meta
    },

    //!Grade
    {
      path: '/admin/grade/create',
      name: 'admin/grade/create',
      component: AdminGradeCreate,
      meta: meta
    }, {
      path: '/admin/grade/update/:uuid',
      name: 'admin/grade/update',
      component: AdminGradeUpdate,
      meta: meta
    },

    //!corretor
    {
      path: '/admin/corretor',
      name: 'admin/corretor',
      component: AdminCorretorIndex,
      meta: meta
    }, {
      path: '/admin/corretor/create',
      name: 'admin/corretor/create',
      component: AdminCorretorCreate,
      meta: meta
    }, {
      path: '/admin/corretor/update/:uuid',
      name: 'admin/corretor/update',
      component: AdminCorretorUpdate,
      meta: meta
    },

    //!Diretor
    {
      path: '/admin/diretor',
      name: 'admin/diretor',
      component: AdminDiretorIndex,
      meta: meta
    }, {
      path: '/admin/diretor/create',
      name: 'admin/diretor/create',
      component: AdminDiretorCreate,
      meta: meta
    }, {
      path: '/admin/diretor/update/:uuid',
      name: 'admin/diretor/update',
      component: AdminDiretorUpdate,
      meta: meta
    },
    
    //Biblioteca
    {
      path: '/admin/biblioteca',
      name: 'admin/biblioteca',
      component: AdminBiblioteca,
      meta: meta
    },


    //####################################################################
    //# ALUNO
    //####################################################################


    //!redacao
    /*
    {
      path: '/aluno/redacao/:cargo_id',
      name: 'aluno/redacao',
      component: AlunoRedacaoIndex,
      meta: meta
    }, {
      path: '/aluno/redacao/create',
      name: 'aluno/redacao/create',
      component: AlunoRedacaoCreate,
      meta: meta
    }, {
      path: '/aluno/redacao/update/:uuid',
      name: 'aluno/redacao/update',
      component: AlunoRedacaoUpdate,
      meta: meta
    },
    */

    //!videos
    {
      path: '/aluno/videos/:cargo_id',
      name: 'aluno/videos',
      component: AlunoVideosIndex,
      meta: meta
    },

    //!simulado
    {
      path: '/aluno/simulado/:cargo_id',
      name: 'aluno/simulado',
      component: AlunoSimuladoIndex,
      meta: meta
    },

    //!perfil
    {
      path: '/aluno/perfil/:cargo_id',
      name: 'aluno/perfil',
      component: AlunoPerfilIndex,
      meta: meta
    },


    //####################################################################
    //# CORRETOR
    //####################################################################


    //!perfil
    {
      path: '/corretor/perfil',
      name: 'corretor/perfil',
      component: CorretorPerfilIndex,
      meta: meta
    },

    //!correcao
    /*
    {
      path: '/corretor/corrigir',
      name: 'corretor/corrigir',
      component: CorretorCorrigirIndex,
      meta: meta
    }, {
      path: '/corretor/corrigir/create/:uuid',
      name: 'corretor/corrigir/create',
      component: CorretorCorrigirCreate,
      meta: meta
    },
    */

  /***
   * REFATORANDO CÓDIGO
   */
  /**
   *  Meta OpenTo
   *    - 'all' -> any user authed
   */

  // Aluno (Admin, Diretor)
  {
    path: '/aluno',
    name: 'aluno',
    component: AlunoIndex,
    meta: {openTo: ['admin', 'diretor']}
  }, {
    path: '/aluno/create',
    name: 'aluno/create',
    component: AlunoSave,
    meta: {openTo: ['admin', 'diretor']}
  }, {
    path: '/aluno/update/:uuid',
    name: 'aluno/update',
    component: AlunoSave,
    meta: {openTo: ['admin', 'diretor']}
  },

  // Material
  // * Index (all)
  // * Create and Update (Admin, Corretor)
  {
    path: '/biblioteca/material',
    name: 'material',
    component: MaterialIndex,
    meta: meta //
  }, {
    path: '/biblioteca/material/create',
    name: 'material/create',
    component: MaterialSave,
    meta: meta
  }, {
    path: '/biblioteca/material/update/:uuid',
    name: 'material/update',
    component: MaterialSave,
    meta: meta
  },

  // Proposta
  // * Index (all)
  // * Create and Update (Admin, Diretor)
  {
    path: '/biblioteca/proposta',
    name: 'proposta',
    component: PropostaIndex,
    meta: {openTo: 'all'}
  }, {
    path: '/biblioteca/proposta/create',
    name: 'proposta/create',
    component: PropostaSave,
    meta: {openTo: ['admin', 'diretor']}
  }, {
    path: '/biblioteca/proposta/update/:uuid',
    name: 'proposta/update',
    component: PropostaSave,
    meta: {openTo: ['admin', 'diretor']}
  }, {
    path: '/biblioteca/proposta/videoaula/:uuid',
    name: 'proposta/videoaula',
    component: PropostaVideoaula,
    meta: {openTo: ['all']}
  },

  // Redação / Corrigir
  // * Index (all) (for aluno -> Minhas redações) (for corretor -> Minhas correções)
  // * Create and Update (Aluno)
  // * Corrigir (Corretor)
  {
    path: '/redacao',
    name: 'redacao',
    component: RedacaoIndex,
    meta: {openTo: 'all'}
  }, {
    path: '/redacao/create',
    name: 'redacao/create',
    component: RedacaoSave,
    meta: {openTo: ['aluno']}
  }, {
    path: '/redacao/update/:uuid',
    name: 'redacao/update',
    component: RedacaoSave,
    meta: {openTo: ['aluno']}
  }, {
    path: '/redacao/corrigir/:uuid',
    name: 'redacao/corrigir',
    component: RedacaoCorrigir,
    meta: {openTo: ['corretor']}
  },
  
  /**************************** 
   */

   {
      path: '/dashboard',
      name: 'dashboard',
   },

   {
    path: '/dashboard-all',
    name: 'dashboard-all',
    component: Dashboard,
 },

    //else if
    {
      path: '*',
      redirect: {
        name: 'login'
      }
    }
    
  ]
})

router.beforeEach((to, from, next) => {
  //console.log(to);
  //\console.log("teste");
  if (!router.resolve(to).route.meta.guest && !store.getters.isAuthenticated) {
    next({ path:'/login' })
  }
  
  else if(router.resolve(to).route.meta.openTo != null){
    if(
      router.resolve(to).route.meta.openTo.indexOf(store.getters.cargo) == -1 &&
      router.resolve(to).route.meta.openTo != 'all'
      )
    {
      next({ path:'/dashboard' }) // redirect to dashboard
    }
    else { next(); }
  }
  else {
    next()
  }
})

router.afterEach((to) => {

  if ((to.path === "/dashboard" || to.path === "/login") && store.getters.isAuthenticated) {

    if (store.getters.isAdmin) {
      router.replace({name: 'dashadmin'})
    }

    else if (store.getters.isCorretor) {
      router.replace({name:'dashcorretor'})
    }

    else if (store.getters.isAluno) {
      router.replace({name:'dashaluno'})
    }

    else if (store.getters.isDiretor) {
      router.replace({name:'dashdiretor'})
    }

    else if (store.getters.isProfessor) {
      router.replace({name:'dashboard-all'})
    }

    // \\\\\\\\\\\\\\
    // Refresh meta reloading page
    // TODO: try refresh meta without reload page, this solution is temporary
    // :: meta is not more to pass store information ::
    router.go();
    // \\\\\\\\\\\\\\
  }
})



export default router